import { TYPE } from 'store/browse-items/fixtures';

export const ACTIONS = {
  [TYPE.ITEM]: [
    {
      name: 'tag',
      title: 'Add tags(s)',
    }, {
      name: 'drawer',
      title: 'Update storage location',
    }, {
      name: 'manufacturer',
      title: 'Update manufacturer',
    }, {
      name: 'layers',
      title: 'Update quantity',
    }, {
      name: 'projects',
      title: 'Add to project',
    }, {
      name: 'set',
      title: 'Add to set',
    }, {
      name: 'heart',
      title: 'Add to wishlist',
    },
    {
      name: 'trash',
      title: 'Delete item(s)',
    },
  ],
  [TYPE.SET]: [
    {
      name: 'plus',
    }, {
      name: 'projects',
      title: 'Add to project',
    }, {
      name: 'trash',
      title: 'Delete set(s)',
    },
  ],
  [TYPE.COLOR]: [
    {
      name: 'trash',
      title: 'Delete color(s)',
    },
  ],
  [TYPE.IMAGE]: [
    {
      name: 'trash',
      title: 'Delete image(s)',
    },
  ],
};

export const LABEL = {
  [TYPE.SET]: 'set',
  [TYPE.ITEM]: 'item',
  [TYPE.COLOR]: 'color',
  [TYPE.IMAGE]: 'image',
};
